import * as React from "react";
import LoginPopup from "../generic/loginPopup";
import DeviceContext from "../../service/indentifyDevice";
import { ELoginPopupState, urls } from "../loginConstants";
import LoginStatus from "../generic/loginStatus";
import { useHistory } from "react-router-dom";
import { getAccData } from "../../service/login/loginService";
import logo from "../../../assets/images/logo_white.jpg";

export interface ILoginStatusScreenProps {
	popupState: ELoginPopupState;
	message?: string;
	onLinkClick?: () => void;
	onButtonClick?: () => void;
	onClose?: () => void;
}

const LoginStatusScreen: React.FC<ILoginStatusScreenProps> = (props) => {
	let status = <></>;
	const history = useHistory();

	switch (props.popupState) {
		case ELoginPopupState.RESET_SUCC:
			status = (
				<LoginStatus
					color="green"
					className="rest_susful"
					icon="edel-icon-tick"
					title="Reset Successful"
					linkTxt="Proceed"
					onLinkClick={props.onLinkClick}
					message={props.message}
				/>
			);
			break;

		case ELoginPopupState.LOGINID_SENT:
			status = (
				<LoginStatus
					className="inactive_account"
					color="blue"
					icon="edel-icon-tick"
					title="Communication Sent"
					linkTxt="Okay"
					link={urls.login}
					message={props.message}
				/>
			);
			break;

		case ELoginPopupState.MERGE_REQUESTED:
			status = (
				<LoginStatus
					className="mergId"
					color="blue"
					icon="edel-icon-tick"
					title="Merge Request Sent"
					subTitle="It will take about 24 hrs to merge your account"
					linkTxt="Proceed"
					onLinkClick={props.onLinkClick}
					message={
						<>
							Until the process is complete, please use your current login IDs for respective accounts. After merger, you will be able to
							login to both your Equity and Commodity accounts using the login ID: <span className="bold-msg">{props.message}</span>
						</>
					}
				/>
			);
			break;

		case ELoginPopupState.EMAIL_SENT:
			status = (
				<LoginStatus
					className="inactive_account"
					color="blue"
					icon="edel-icon-tick"
					title="Email Sent"
					linkTxt="Okay"
					link={urls.login}
					message={
						"An email has been sent with the form and instructions on how to activate your " +
						(getAccData("accTyp") === "EQ" ? "Commodity" : "Equity") +
						" account"
					}
				/>
			);
			break;

		case ELoginPopupState.INACTIVE_ACC:
			status = (
				<LoginStatus
					className="comm_inactive_account"
					color="red"
					icon="edel-icon-exclamation"
					title={(getAccData("accTyp") === "EQ" ? "Commodity" : "Equity") + " Account Inactive"}
					linkTxt="No, Thanks"
					onLinkClick={props.onLinkClick}
					message="In order to place trade online, you’ll need to activate your account first"
					btnValue="Mail me the activation form"
					onButtonClick={props.onButtonClick}
				/>
			);
			break;

		case ELoginPopupState.OPEN_ACC_SUCC:
			status = (
				<LoginStatus
					color="green"
					icon="edel-icon-tick"
					title="Received Request"
					linkTxt="Okay"
					onLinkClick={props.onLinkClick}
					message={props.message}
				/>
			);
			break;

		case ELoginPopupState.REQUESTED:
		case ELoginPopupState.NOT_ENABLED:
			const accTyp = getAccData("accTyp");
			status = (
				<LoginStatus
					className="multiple_account"
					color="blue"
					icon="edel-icon-arrow-right"
					message={
						props.popupState === ELoginPopupState.REQUESTED
							? "It will take about 24 hours to complete your account merger. Until then log in with your " +
							  (accTyp === "EQ" ? "Commodity" : "Equity") +
							  " account to place trade."
							: "You are currently logged into your " +
							  (accTyp === "EQ" ? "Equity" : "Commodity") +
							  " account. To place a " +
							  (accTyp === "EQ" ? "commodity" : "equity") +
							  " trade, you need to switch to your " +
							  (accTyp === "EQ" ? "commodity" : "equity") +
							  " account."
					}
					btnValue="Logout & Proceed"
					onButtonClick={props.onButtonClick}
				/>
			);
			break;

		case ELoginPopupState.ONE_ACCOUNT:
			status = (
				<LoginStatus
					className="comm_inactive_account"
					color="red"
					icon="edel-icon-exclamation"
					title={"Need " + (getAccData("accTyp") === "EQ" ? "Commodity" : "Equity") + " Account"}
					linkTxt="No, Thanks"
					onLinkClick={props.onLinkClick}
					message={
						"In order to place trade in commodities you will need a " +
						(getAccData("accTyp") === "EQ" ? "commodity" : "equity") +
						" account. Would you like to open one now?"
					}
					btnValue="Yes, Right Away"
					onButtonClick={props.onButtonClick}
				/>
			);
			break;

		case ELoginPopupState.LOGIN_FAILED:
			status = (
				<LoginStatus
					className="comm_inactive_account"
					color="red"
					icon="edel-icon-exclamation"
					title="Login Failed"
					linkTxt="Login"
					onLinkClick={props.onLinkClick}
					message={props.message}
					btnValue="Go to home page"
					onButtonClick={() => history.push(urls.home)}
				/>
			);
			break;
	}

	return (
		<LoginPopup
			leftHeaderContent={!DeviceContext().isDesktop ? <img src={logo} alt="nuvama" className="nuvama_logo"/> : undefined}
			centerHeaderContent={DeviceContext().isDesktop ? <img src={logo} alt="nuvama" className="nuvama_logo"/> : undefined}
			onClose={props.onClose}
			className="login_sts"
		>
			{status}
		</LoginPopup>
	);
};

export default LoginStatusScreen;
